import moment, { Moment } from "moment";
import { createContext, useContext, useEffect, useState } from "react";

const TodayContext = createContext<Moment>(moment());

export const TodayProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [today, setToday] = useState(() => moment());

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    const scheduleUpdate = () => {
      const msUntilMidnight = moment().endOf("hour").diff(moment()) + 1;
      timeoutId = setTimeout(() => {
        setToday(moment());
        scheduleUpdate();
      }, msUntilMidnight);
    };

    scheduleUpdate();
    return () => clearTimeout(timeoutId);
  }, []);

  return <TodayContext.Provider value={today}>{children}</TodayContext.Provider>;
};

export const useToday = () => useContext(TodayContext);
